import * as React from 'react'

export const SVG_Success = ({ className }: { className?: string }) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <g fill="currentColor" fillRule="evenodd">
            <path d="M18.277 10a8.22 8.22 0 0 1-2.427 5.85A8.221 8.221 0 0 1 10 18.277c-4.564 0-8.277-3.713-8.277-8.277 0-4.564 3.713-8.277 8.277-8.277 4.564 0 8.277 3.713 8.277 8.277M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0" />
            <path d="M14.113 6a.909.909 0 0 0-.627.245l-5.033 4.739-1.939-1.826a.928.928 0 0 0-1.254 0 .806.806 0 0 0-.26.59c0 .224.092.434.26.592l2.566 2.416a.91.91 0 0 0 .627.244.91.91 0 0 0 .628-.245l5.659-5.33a.806.806 0 0 0 .26-.59.806.806 0 0 0-.26-.59.91.91 0 0 0-.627-.245" />
        </g>
    </svg>
)
